import React, { useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import throttle from 'lodash/throttle';

// import { truncate } from 'shared/utility';
import { formatDateFromISO } from 'shared/date';
import { getUserLS } from 'shared/localStorage';
import { getSingleArticleSelector } from 'store/strapi/selector';
import { getSingleArticleRequest } from 'store/strapi/actions';

import WithHeaderAndFooter from 'components/Wrappers/HeaderFooterWrapper';
// import RelatedArticle from './RelatedArticle/RelatedArticle';

import articleImg from 'assets/temp/article.jpg';
import avatar from 'assets/images/avatar_k_chess.png';
import { ReactComponent as Clock } from 'assets/icons/clock.svg';
import { ReactComponent as Right } from 'assets/icons/arrows/arrow_right.svg';
// import { ReactComponent as Share } from 'assets/temp/share.svg';

import styles from './Article.module.scss';

const Article = ({ match, history }) => {
    // const [data, setData] = useState(null);
    const singleArticle = useSelector(getSingleArticleSelector, shallowEqual);

    const dispatch = useDispatch();

    const userInfo = JSON.parse(getUserLS());

    // const fetchData = async (id) => {
    //     try {
    //         const response = await STRAPI.get(`/articles/${id}`);
    //         setData(response.data);
    //     } catch (error) {
    //         history.push('/404');
    //     }
    // };

    const onScroll = throttle(() => {
        const currentScrollPos = window.pageYOffset;
        const author = document.getElementById('author');
        const article_box = document.getElementById('article_box');
        const progress_bar = document.getElementById('progress_bar');

        author &&
            Object.assign(author.style, {
                opacity: Math.max(0, 0 + currentScrollPos / 300),
            });

        if (article_box && progress_bar) {
            if (
                article_box.offsetTop -
                    document.documentElement.scrollTop -
                    56 <=
                0
            ) {
                const winScroll =
                    document.documentElement.scrollTop -
                    article_box.offsetTop +
                    112;
                const height = article_box.clientHeight - 96;
                const scrolled = (winScroll / (height - 600)) * 100;
                progress_bar.style.width = `${scrolled}%`;
            } else {
                progress_bar.style.width = '0%';
            }
        }
	}, 50);

	useEffect(() => {
		if (window.instgrm) {
			window.instgrm.Embeds.process();
		}
	}, [singleArticle]);

    useEffect(() => {
        // fetchData(match.params.id);
        dispatch(getSingleArticleRequest(match.params.id));

        window.addEventListener('scroll', onScroll);

        return () => {
			window.removeEventListener('scroll', onScroll);
        };
    }, []);

    return (
        <div className={styles.article}>
            {singleArticle && (
                <WithHeaderAndFooter userInfo={userInfo}>
                    <div className={styles.progress_container}>
                        <div
                            className={styles.progress_bar}
                            id="progress_bar"
                        ></div>
                    </div>
                    <div className={styles.breadcrumbs}>
                        <Link to="/home">Home</Link>{' '}
                        <span>
                            <Right />
                        </span>{' '}
                        {(singleArticle && singleArticle.title) || 'Article'}
                    </div>
                    {/* <div className={styles.breadcrumbs}><Link to='/home'>Home</Link> <span><Right /></span> {truncate((singleArticle && singleArticle.title) || 'Article', 25)}</div> */}
                    <main>
                        <section className={styles.header}>
                            <div></div>
                            <div className={styles.header_content}>
                                <div className={styles.title}>
                                    {(singleArticle && singleArticle.title) ||
                                        'Article'}
                                </div>
                                <div className={styles.data}>
                                    <div>
                                        Written by{' '}
                                        {singleArticle &&
                                            singleArticle.author &&
                                            singleArticle.author.name}{' '}
                                        •{' '}
                                        {singleArticle &&
                                            formatDateFromISO(
                                                singleArticle.date_posted,
                                                'D T Y'
                                            )}{' '}
                                        •{' '}
                                        <span>
                                            <Clock />{' '}
                                            {singleArticle &&
                                                (Math.round(
                                                    singleArticle.time_to_read
                                                ) === 0
                                                    ? '1'
                                                    : Math.round(
                                                          singleArticle.time_to_read
                                                      ))}{' '}
                                            min
                                        </span>
                                    </div>
                                    <div>{/* <Share/> */}</div>
                                </div>
                                {singleArticle && (
                                    <div className={styles.container}>
                                        <div
                                            className={styles.image_container}
                                            style={{
                                                backgroundImage: `url(${(singleArticle.hero_image &&
                                                    singleArticle.hero_image
                                                        .url) ||
                                                    (singleArticle.thumbnail &&
                                                        singleArticle.thumbnail
                                                            .url) ||
                                                    articleImg})`,
                                            }}
                                        ></div>
                                    </div>
                                )}
                            </div>
                            <div></div>
                        </section>
                        <section
                            className={styles.article_box}
                            id="article_box"
                        >
                            <div></div>
                            <section>
                                <div className={styles.sticky_container}>
                                    <div className={styles.author} id="author">
                                        <div className={styles.author_header}>
                                            {singleArticle && (
                                                <img
                                                    src={
                                                        (singleArticle.author &&
                                                            singleArticle.author
                                                                .avatar.formats
                                                                .small.url) ||
                                                        avatar
                                                    }
                                                    alt=""
                                                />
                                            )}
                                            <div>
                                                <div>
                                                    Written by{' '}
                                                    {singleArticle &&
                                                        singleArticle.author &&
                                                        singleArticle.author
                                                            .name}
                                                </div>
                                                <div>
                                                    {singleArticle &&
                                                        formatDateFromISO(
                                                            singleArticle.date_posted,
                                                            'D T Y'
                                                        )}{' '}
                                                    • <Clock />{' '}
                                                    {singleArticle &&
                                                        (Math.round(
                                                            singleArticle.time_to_read
                                                        ) === 0
                                                            ? '1'
                                                            : Math.round(
                                                                  singleArticle.time_to_read
                                                              ))}{' '}
                                                    min
                                                </div>
                                            </div>
                                        </div>
                                        <div className={styles.author_bio}>
                                            {singleArticle &&
                                                singleArticle.author &&
                                                singleArticle.author.bio}
                                        </div>
                                        <div className={styles.author_footer}>
                                            {/* <Share/> */}
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <ReactMarkdown
                                        escapeHtml={false}
                                        className={styles.content}
                                    >
                                        {singleArticle && singleArticle.content}
                                    </ReactMarkdown>
                                    <div className={styles.author_bottom}>
                                        <div className={styles.author_header}>
                                            {singleArticle && (
                                                <img
                                                    src={
                                                        (singleArticle.author &&
                                                            singleArticle.author
                                                                .avatar.formats
                                                                .small.url) ||
                                                        avatar
                                                    }
                                                    alt=""
                                                />
                                            )}
                                            <div>
                                                <div>
                                                    Written by{' '}
                                                    {singleArticle &&
                                                        singleArticle.author &&
                                                        singleArticle.author
                                                            .name}
                                                </div>
                                                <div>
                                                    {singleArticle &&
                                                        formatDateFromISO(
                                                            singleArticle.date_posted,
                                                            'D T Y'
                                                        )}{' '}
                                                    • <Clock />{' '}
                                                    {singleArticle &&
                                                        (Math.round(
                                                            singleArticle.time_to_read
                                                        ) === 0
                                                            ? '1'
                                                            : Math.round(
                                                                  singleArticle.time_to_read
                                                              ))}{' '}
                                                    min
                                                </div>
                                            </div>
                                        </div>
                                        <div className={styles.author_bio}>
                                            {singleArticle &&
                                                singleArticle.author &&
                                                singleArticle.author.bio}
                                        </div>
                                        <div className={styles.author_footer}>
                                            {/* <Share/> */}
                                        </div>
                                    </div>
                                </div>
                                <div></div>
                            </section>
                        </section>
                        {/* <div className={styles.article_footer}>
						<h2>Related articles</h2>
					</div> */}
                    </main>
                </WithHeaderAndFooter>
            )}
        </div>
    );
};

export default Article;
